var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$route.meta.isHiddenBar ? 'isHiddenBar' : '',attrs:{"id":"app"}},[_c('router-view',{staticClass:"main",style:(_vm.$route.meta.isHiddenBar ? { paddingBottom: '0' } : '')}),_c('TabBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }